(() => {
  if (customElements.get("slich-restock-alert")) return;
  const origin = "https://geoprint-shopify.vercel.app";
  customElements.define(
    "slich-restock-alert",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearInterval(this.timer);
        this.controller = new AbortController();
        this.select = this.querySelector("select");
        this.link = this.querySelector("a");
        if (
          !this.select ||
          !this.link ||
          !/^[a-z0-9][a-z0-9-]{0,99}$/.test(this.dataset.handle ?? "")
        )
          return;
        this.select.addEventListener("change", () => this.updateLink(), {
          signal: this.controller.signal
        });
        this.refresh = () => this.load();
        window.addEventListener("focus", this.refresh, { signal: this.controller.signal });
        this.timer = setInterval(this.refresh, 60000);
        void this.load();
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearInterval(this.timer);
      }
      updateLink() {
        const url = new URL("/retour-en-stock", origin);
        url.searchParams.set("produit", this.dataset.handle);
        url.searchParams.set("variante", this.select.value);
        this.link.href = url.href;
        const selected = this.querySelector("[data-restock-selected]");
        if (selected) {
          selected.textContent = this.select.selectedOptions[0]?.textContent ?? "";
          selected.hidden = this.select.closest("label").hidden;
        }
      }
      renderShirtChoices(variants, previous) {
        if (
          variants.some(
            (variant) => !Array.isArray(variant.options) || variant.options.length !== 3
          )
        )
          return false;
        const choices = variants.map((variant) => ({
          variant,
          parts: [...variant.options.slice(0, 2), ...String(variant.options[2] ?? "").split(" · ")]
        }));
        if (
          !choices.length ||
          choices.some(({ parts }) => parts.length !== 5 || parts.some((part) => !part))
        )
          return false;
        const keys = choices.map(({ parts }) => JSON.stringify(parts));
        if (new Set(keys).size !== keys.length) return false;
        const labels = ["range", "size", "colour", "printSize", "printSide"].map(
          (key, index) =>
            this.dataset[key] ||
            ["Gamme", "Taille", "Couleur", "Format du marquage", "Face imprimée"][index]
        );
        const old = choices.find(({ variant }) => variant.id === previous) ?? choices[0];
        const selected = [...old.parts];
        const group = document.createElement("div");
        group.className = "slich-restock-choices";
        const controls = labels.map((label) => {
          const wrapper = document.createElement("label");
          wrapper.textContent = label;
          const control = document.createElement("select");
          control.setAttribute("aria-label", label);
          wrapper.append(control);
          group.append(wrapper);
          return control;
        });
        const update = () => {
          let possible = choices;
          controls.forEach((control, index) => {
            const values = [...new Set(possible.map(({ parts }) => parts[index]))];
            if (!values.includes(selected[index])) selected[index] = values[0];
            control.replaceChildren(
              ...values.map((value) => {
                const option = document.createElement("option");
                option.value = value;
                option.textContent = value;
                return option;
              })
            );
            control.value = selected[index];
            possible = possible.filter(({ parts }) => parts[index] === selected[index]);
          });
          if (possible.length !== 1) return;
          this.select.value = possible[0].variant.id;
          this.updateLink();
        };
        controls.forEach((control, index) =>
          control.addEventListener(
            "change",
            () => {
              selected[index] = control.value;
              update();
            },
            { signal: this.controller.signal }
          )
        );
        this.querySelector(".slich-restock-choices")?.remove();
        this.select.closest("label").hidden = true;
        this.select.closest("label").after(group);
        update();
        return true;
      }
      async load() {
        if (this.loading || !this.isConnected) return;
        this.loading = true;
        try {
          const response = await fetch(
            `${origin}/api/catalogue/disponibilite?produit=${encodeURIComponent(this.dataset.handle)}`,
            {
              cache: "no-store",
              credentials: "omit",
              signal: this.controller.signal
            }
          );
          if (!response.ok) throw new Error("unavailable");
          const data = await response.json();
          if (data.handle !== this.dataset.handle || !Array.isArray(data.variants))
            throw new Error("invalid");
          if (
            data.variants.length > 2048 ||
            data.variants.some(
              (v) =>
                !v ||
                !/^\d{1,30}$/.test(v.id) ||
                typeof v.title !== "string" ||
                typeof v.available !== "boolean"
            ) ||
            new Set(data.variants.map((v) => v.id)).size !== data.variants.length
          )
            throw new Error("invalid");
          const variants = data.variants.filter(
            (v) =>
              (this.dataset.handle !== "eco-cup-personnalise" ||
                (Array.isArray(v.options) &&
                  (v.options.length < 3 || v.options[2] === "1 gobelet"))) &&
              v.available === false
          );
          this.hidden =
            data.alertsEnabled !== true ||
            ["preparation", "quote"].includes(data.state) ||
            variants.length === 0;
          if (this.hidden) return;
          const signature = JSON.stringify(variants.map((v) => [v.id, v.title, v.options]));
          if (signature === this.signature) return;
          const previous = this.select.value || new URL(location.href).searchParams.get("variant");
          this.select.replaceChildren(
            ...variants.map((v) => {
              const option = document.createElement("option");
              option.value = v.id;
              option.textContent =
                this.dataset.handle === "carnet-personnalise"
                  ? v.title.replace(/^ARCONOT A5 · Blanc(?= \/|$)/, "Carnet A5 · Blanc")
                  : v.title;
              return option;
            })
          );
          if (variants.some((v) => v.id === previous)) this.select.value = previous;
          if (
            this.dataset.handle !== "t-shirt-personnalise" ||
            !this.renderShirtChoices(variants, previous)
          ) {
            this.querySelector(".slich-restock-choices")?.remove();
            this.select.closest("label").hidden = false;
            this.updateLink();
          }
          this.signature = signature;
        } catch {
          this.hidden = true;
        } finally {
          this.loading = false;
        }
      }
    }
  );
})();
